import React, {Component, Fragment} from 'react';
import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import se_sm_intro from 'assets/sounds/se/intros/NonWOrdInstruction.mp3';

class IntroNonwords extends Component {
	constructor(props) {
		super(props);
		this.audio =  se_sm_intro;
	}
	render() {
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.nono_intro1}
					<br />
			
				</p>
				<ReadyButton onReadyChange={this.props.setReady} />
			</Fragment>
		);
	}
}

export default IntroNonwords;
